import { SvgIcon } from '@material-ui/core';
import { ReactComponent as stampIcon } from './stampIcon.svg';

export default function StampIcon(props) {
  return <SvgIcon {...props} component={stampIcon} viewBox="0 0 12 12" />;
}
